export default __webpack_public_path__ + "static/media/logo.d3d0fa01.png";